exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".magnifier-component{display:flex;position:relative}.magnifier-component .magnifier-bg{background-image:url(\"/assets/images/magnifier.png\");height:300px;width:480px;position:absolute;background-size:contain;background-repeat:no-repeat;z-index:1;transform:rotate(229deg)}.magnifier-component .img-magnifier-container{position:relative}.magnifier-component .img-magnifier-glass{position:absolute;border:1px solid #ccc;background-color:#fff;cursor:none;width:300px;height:300px;border-radius:50%;box-shadow:0 0 10px -1px #000;z-index:3}.magnifier-component .img-magnifier-glass_hidden{visibility:hidden}.magnifier-component .img-zoom-container{position:relative}.magnifier-component .img-zoom-lens{position:absolute;border:1px solid #d4d4d4;width:170px;height:120px;background:#ccc;opacity:.5}.magnifier-component .img-zoom-lens_hidden{visibility:hidden}.magnifier-component .img-zoom-result{position:absolute;border:1px solid #d4d4d4;width:250px;height:250px;right:0}.magnifier-component .img-zoom-result_hidden{visibility:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/magnifier/magnifier.scss
// module id = 890
// module chunks = 0